var map = {
	"./belonging.svg": 242,
	"./enter.svg": 9571,
	"./globe-mask-all.svg": 8009,
	"./hand-no-globe.svg": 6068,
	"./neurodiversity.svg": 7597,
	"./people.svg": 1486,
	"./physicalNeeds.svg": 7443,
	"./wellbeing.svg": 6656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;